import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button } from 'planoplan-ui-kit/core/button';
import { ButtonLoader } from 'planoplan-ui-kit/core/buttonLoader';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { getImage } from 'planoplan-ui-kit/core/get_image';
import { Points, textSize } from '@styles';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { useTranslations } from '@libs/translations';
import { useDispatch, useSelector } from 'react-redux';
import {ON_OPEN_ENTRY_MODAL, ON_SUCCESS_LOGIN} from '@constants/observer';
import { ui } from '@layouts';
import { openProject } from '../effects';
import {PROCESSING_ITEMS} from '@constants';

export const Banner = ({ fileWidget, title }) => {
  const translations = useTranslations();
  const dispatch = useDispatch();
  const { loading, user } = useSelector((state) => state);
  const isUser = Boolean(user);
  const isOpeningProject = loading[PROCESSING_ITEMS.OPEN_PROJECT];

  const onOpenProject = () => {
    if (isUser) {
      dispatch(openProject(fileWidget, title));
    } else {
      ui.postMessage(ON_OPEN_ENTRY_MODAL, { step: 'signup', redirectUrl: '/', props: { isAfterOpenProject: true }});
    }
  };

  useEffect(() => {
    ui.addEventListener(ON_SUCCESS_LOGIN, () => {
      if (fileWidget) {
        dispatch(openProject(fileWidget, title));
      }
    });
  }, []);

  return (
      <Container>
        <Content>
          <Icon>
            <img src={getImage('icons/painter.png')} alt=""/>
          </Icon>
          <Text>{translations.t('site.galleryProjects.banner.text')}</Text>
          <Open>
            <ButtonLoader
                type="button"
                loading={isOpeningProject}
                theme="primary"
                size={'M'}
                device={{ isMobile: deviceDetected.isMobile }}
                onClick={onOpenProject}>
              {translations.t('site.galleryProjects.banner.open')}
            </ButtonLoader>
          </Open>
          <Favorite>
            {/*<Button
                theme="secondary"
                size={'M'}
                device={{ isMobile: deviceDetected.isMobile }}
                onClick={onAddFavorite}>
              {translations.t('site.galleryProjects.banner.favorite')}
            </Button>*/}
          </Favorite>
        </Content>
      </Container>
  );
};

const Container = styled.div`
  position: sticky;
  top: 80px;
  width: 280px;
  height: 370px;
  display: none;

  @media ${Points.laptop} {
    display: block;
  }
`;

const Content = styled.div`
  border-radius: 20px;
  padding: 20px;
  background-color: ${Colors.white};
  border: 1px solid #FFB540;

  @media ${Points.laptop} {
    padding: 30px;
  }
`;

const Icon = styled.div`
  margin-bottom: 15px;
  width: 40px;
  height: 40px;
  
  img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
  }
`;

const Text = styled.div`
  color: ${Colors.black};
  ${textSize('list_header')};
`;

const Open = styled.div`
  margin-top: 20px;
`;

const Favorite = styled.div`
  margin-top: 10px;
  white-space: nowrap;
`;


